import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { SITE_ACRONYM, SITE_NAME } from '../../../config/Master';
import breakpoints from 'theme/material/breakpoints';

const CenterDashDiv = styled('div')({
  textAlign: 'center',
  borderTop: '1px dashed #C9C9C9',
  padding: 20,
  [breakpoints.down(639.05)]: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const SpanText = styled('span')({
  fontSize: 16,
  [breakpoints.down(639.05)]: {
    fontSize: 15,
  },
  [breakpoints.down(479.05)]: {
    fontSize: 14,
  },
});

const TransactionAwareness = (): ReactElement => {
  return (
    <CenterDashDiv>
      <SpanText>
        {SITE_ACRONYM.toUpperCase()} Date Offers are <b>not</b> exchanged or processed through the {SITE_NAME} app.
        Besides in person cash transactions, you may also safely utilize the services of available online 3rd party
        payment processors and escrow apps.
      </SpanText>
    </CenterDashDiv>
  );
};

export default TransactionAwareness;
